import React from 'react';
import colors from '../../../../helpers/colors';
import componentProps from '../../../../helpers/componentProps';
import { applyComponentTheme } from '../../../../theme';
import { SubPanelButtonProps } from '../../types';
import { MobileLabelWrapper, MobilePanelButtonStyle, StyledIcon } from './styles';

const MobilePanelButton: React.FC<SubPanelButtonProps> = ({
  index,
  isSelected,
  label,
  setCurrentTabIndex,
  onClick,
  ...props
}) => {
  return (
    <MobilePanelButtonStyle
      isSelected={isSelected}
      disabled={isSelected}
      key={index}
      data-testid={`Mobile-panel-button-${index}`}
      onClick={(e) => {
        setCurrentTabIndex(index);
        if (onClick) {
          onClick(e);
        }
      }}
      {...componentProps(props)}>
      <MobileLabelWrapper>{label}</MobileLabelWrapper>
      <StyledIcon
        data-testid={`Mobile-panel-icon-${index}`}
        name="arrow-down"
        size="small"
        color={isSelected ? colors.neutral08 : colors.core01}
        flipY={isSelected}
      />
    </MobilePanelButtonStyle>
  );
};

export default applyComponentTheme(MobilePanelButton, 'MobilePanelButton');
